<template>
  <div class="container-fluid">
    <b-overlay :show="showOverlay" rounded="sm">
      <b-col class="container text-right"> </b-col>

      <b-card class="mt-2 col-12">
        <b-col cols="12">
          <SearchFilter
            @handleSubmit="searchFilterSubmit"
            :mode="'SearchAll'"
            :autoSearch="false"
          />
        </b-col>
      </b-card>

      <b-card>
        <commonTable
          ref="tableCommon"
          :routeName="$route.name"
          :tableHeader="tableHeader"
          :searchMode="'SearchAll'"
          @handleGroup="getManageGroup"
          @handleOverlay="setOverlay"
        />
      </b-card>
      <ModalMaintenance
        ref="ModalMaintenance"
        :maintenance="maintenance"
      ></ModalMaintenance>
    </b-overlay>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BTabs,
  BTab,
  BButton,
  BCard,
  BCardHeader,
  BCardBody,
  BOverlay,
} from "bootstrap-vue";
import * as userData from "@/auth/localStorageUtils.js";
import commonTable from "@/views/Complaint/components/vueGoodTable/commonTable.vue";
import commonTableHeader from "@/views/Complaint/components/vueGoodTable/commonTableHeader.js";
import SearchFilter from "@/views/Complaint/components/vueGoodTable/SearchFilter.vue";

import * as apiEditDom from "@/store/api/editorDom/index.js";
import ModalMaintenance from "@/views/Complaint/components/ModalMaintenance.vue";

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BTabs,
    BTab,
    BCard,
    BCardHeader,
    BCardBody,
    BOverlay,
    commonTable,
    SearchFilter,
    ModalMaintenance,
  },
  data() {
    return {
      showOverlay: false,
      tableHeader: commonTableHeader,
      maintenance: "",
    };
  },
  mounted() {
    this.onGetMaintenance();
  },
  methods: {
    searchFilterSubmit(params) {
      this.$refs.tableCommon.onSearchSubmit(params);
    },
    onBtnAddClicked() {
      window.open(
        this.$router.resolve({
          name: "MasterPurchaseManage",
          query: { masterTypeId },
        }).href,
        "_blank",
      );
    },
    getManageGroup(id) {
      const routeData = this.$router.resolve({
        name: "ComplaintMainSearchDetail",
        query: { id },
      });
      window.open(routeData.href, "_blank");
    },
    setOverlay(isShow) {
      this.showOverlay = isShow;
    },
    onGetMaintenance() {
      apiEditDom
        .getById("Maintenance")
        .then((response) => {
          // console.log("onGetMaintenance: response", response);
          if (response.data.data !== null && response.data.data !== undefined) {
            // console.log(
            //   "onGetMaintenance: response.data.data",
            //   response.data.data
            // );
            this.maintenance = response.data.data.domTh;

            const today = new Date().toISOString().split("T")[0];
            const hiddenDate = localStorage.getItem("maintenance_hide_until");

            if (hiddenDate !== today) {
              this.$bvModal.show("modal-maintenance");
            }
            
            this.$refs.ModalMaintenance.$refs["modal-maintenance"].show();
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
